import { render, staticRenderFns } from "./SvgName.vue?vue&type=template&id=284286a2&scoped=true&"
import script from "./SvgName.vue?vue&type=script&lang=js&"
export * from "./SvgName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284286a2",
  null
  
)

export default component.exports